<template>
  <fetch-json :url="url" @json-loaded="triggerScroll">
    <template slot-scope="{ json: docs, loading }">
      <div class="columns">
        <div class="column">
          <div class="container">
            <h4 class="title is-4">
              Все результаты
              <span class="has-text-grey" v-if="docs && docs.length > 0"
                >{{ docs.length }} {{ documentWord(docs.length) }}</span
              >
            </h4>

            <GisogdSectionDocs
              v-if="docs && docs.length > 0"
              :docs="docs"
              :project-schema="projectSchema"
              class="box"
            ></GisogdSectionDocs>
            <div v-else>
              <p v-if="loading">Пожалуйста, подождите...</p>
              <p v-else>Ничего не найдено.</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </fetch-json>
</template>
<script>
import GisogdSectionDocs from "./Docs";
export default {
  props: {
    projectSchema: {
      required: true,
      type: String,
    },
    searchText: {
      type: String,
      default: "",
    },
  },
  components: {
    GisogdSectionDocs,
  },
  computed: {
    url() {
      return `v1/docsearch/${this.projectSchema}?search=${this.searchText}`;
    },
  },
  methods: {
    documentWord(number) {
      const cases = [2, 0, 1, 1, 1, 2];
      const titles = ["документ", "документа", "документов"];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    async triggerScroll() {
      await this.$nextTick();
      this.$root.$emit("triggerScroll");
    },
  },
};
</script>